import { render, staticRenderFns } from "./FormNguoiDung.vue?vue&type=template&id=4af78164&"
import script from "./FormNguoiDung.vue?vue&type=script&lang=js&"
export * from "./FormNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports